export const isDevelopment = process.env.NODE_ENV === "development";
export const isDemoMode = process.env.REACT_APP_DEMO === "true";
